import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import queryString from "query-string";
import AdContentManagers from '../../components/AdManager/AdContentManagers';
import AdHistories from '../../components/AdManager/AdHistories';

const AdManagers = () => {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState("content");

  const { user } = useSelector(
    (store) => ({
      user: store.Profile.user,
    }),
    shallowEqual
  );

  const _setActiveTab = (value) => {
    history.push(`/admin/ad/manager?tab=${value}`);
  };

  const tabList = [
    {
      label: (
        <>
          컨텐츠 관리 <small className="color-red-100 font-size-10">new</small>
        </>
      ),
      action: _setActiveTab,
      value: "content",
    },
    {
      label: (
        <>
          컨텐츠별 데이터 관리 <small className="color-red-100 font-size-10">new</small>
        </>
      ),
      action: _setActiveTab,
      value: "history",
    },
  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history.location]);


  return (
    <>
      <PageHeader
        title={`안녕하세요, ${user && user.name}님.`}
        activeTab={activeTab}
        tabList={tabList}
      />
      {activeTab === "content" && <AdContentManagers />}
      {activeTab === "history" && <AdHistories />}
    </>
  );
};

export default AdManagers;